<div
	class="auto-complete"
	[ngClass]="{
		'has-icon': !!inputIconClasses,
		'browse-button-active': browseButtonActive(),
		dense: isDense(),
		subordinated: isInSubordinatedElementsMode(),
	}"
>
	<label class="relative input">
		@if (inputIconClasses) {
			<i [ngClass]="inputIconClasses"></i>
		}
		<input
			#autoCompleteInput
			autoComplete="off"
			[(ngModel)]="term"
			id="term"
			name="term"
			type="search"
			class="search"
			[maxlength]="maxTermLength()"
			[attr.placeholder]="placeholder()"
			(blur)="onBlur($event)"
			stagesAutofocus
		/>
	</label>
	@if (browseButtonActive()) {
		<button
			type="button"
			[attr.title]="'navigation.workspace.select' | translate"
			[attr.aria-label]="'navigation.workspace.select' | translate"
			id="open-browser"
			class="open-browser"
			(click)="openBrowser()"
		>
			<i class="ico ico-workspace"></i>
		</button>
		<button
			type="button"
			[attr.title]="'close' | translate"
			[attr.aria-label]="'close' | translate"
			class="search-close clickable"
			(click)="closeSearch()"
		>
			<i class="ico ico-close"></i>
		</button>
	}
	@if (dropDownOpen || isInSubordinatedElementsMode() || !searchEngineAvailable()) {
		<div class="dropdown" [ngClass]="dropDownClass()!">
			<div class="dropdown-wrapper">
				<div class="dropdown-inner">
					@if (!isInSubordinatedElementsMode()) {
						<div
							class="dropdown-item stages-slide-x"
							[style.--stages-slide-from]="animationParams.enterFrom + '%'"
							[style.--stages-slide-to]="animationParams.enterTo + '%'"
						>
							<ul
								class="dropdown-list stages-slide-x"
								[style.--stages-slide-from]="animationParams.enterFrom + '%'"
								[style.--stages-slide-to]="animationParams.enterTo + '%'"
							>
								<ng-container *ngTemplateOutlet="resultList; context: { $implicit: results() }"></ng-container>
							</ul>
						</div>
					} @else {
						<div
							class="dropdown-item stages-slide-x"
							[style.--stages-slide-from]="animationParams.enterFrom + '%'"
							[style.--stages-slide-to]="animationParams.enterTo + '%'"
						>
							<ul class="dropdown-list">
								@if (backButtonActive()) {
									<li [ngClass]="{ selected: isSelected(BACK_BUTTON_INDEX) }">
										<a class="clickable" title="{{ 'back' | translate }}" (click)="back()">
											<i class="ico ico-chevron-left"></i>
											<div class="label subordinated" translate="back"></div>
										</a>
									</li>
								}
								<ng-container
									*ngTemplateOutlet="resultList; context: { $implicit: subordinatedResults, isSubordinated: true }"
								></ng-container>
							</ul>
						</div>
					}
				</div>
			</div>
		</div>
	}
</div>

<ng-template #resultList let-resultsToUse let-isSubordinated="isSubordinated">
	@for (result of resultsToUse; track result; let index = $index) {
		@if (showListItem(result, isSubordinated)) {
			<li [ngClass]="{ selected: isSelected(index) }">
				@if (!$any(result).isSeparator) {
					<a class="clickable" (click)="onSelect(result)" (mousedown)="onMouseDown()">
						<ng-container *ngTemplateOutlet="searchResultTemplate()!; context: { $implicit: result }"></ng-container>
					</a>
				}
			</li>
		}
		@if (searchResultSeparatorTemplate && index < resultsToUse.length - 1) {
			<ng-container
				*ngTemplateOutlet="
					searchResultSeparatorTemplate;
					context: { $implicit: { current: resultsToUse[index], next: resultsToUse[index + 1] } }
				"
			/>
		}
	}
	<ng-container *ngTemplateOutlet="noResultOrSearchEngineUnavailable" />
</ng-template>

<ng-template #noResultOrSearchEngineUnavailable>
	@if (hasNoResults() && searchEngineAvailable()) {
		<li class="no-results">
			<p translate="search.noresults"></p>
		</li>
	}
	@if (!searchEngineAvailable()) {
		<li class="no-results">
			<p translate="search.notavailable"></p>
		</li>
	}
</ng-template>
